__turbopack_context__.v({
  "className": "inter_1558b925-module__1pnGSG__className",
  "variable": "inter_1558b925-module__1pnGSG__variable",
});
